import { Link } from "react-router";

import { cn } from "@/utils/tailwind";

interface LogoProps {
  className?: string;
  compact?: boolean;
  linkTo?: string;
}

// Turn the universal pause gesture into a compact, durable archive mark.
export function Logo({ className, compact = false, linkTo }: LogoProps) {
  const mark = (
    <span className={cn("inline-flex items-center gap-2.5", className)}>
      <svg
        aria-hidden="true"
        className="size-8 overflow-visible"
        fill="none"
        viewBox="0 0 32 32"
      >
        <circle className="fill-primary" cx="16" cy="16" r="14" />
        <rect
          className="fill-primary-foreground"
          height="13"
          rx="1.75"
          width="3.5"
          x="10.25"
          y="9.5"
        />
        <rect
          className="fill-primary-foreground"
          height="13"
          rx="1.75"
          width="3.5"
          x="18.25"
          y="9.5"
        />
      </svg>
      {!compact && (
        <span className="inline-flex items-baseline gap-1.5">
          <span className="font-serif text-xl font-semibold tracking-[-0.02em]">
            Paused
          </span>
          <span className="text-primary font-mono text-[0.58rem] font-bold tracking-[0.16em] uppercase">
            FYI
          </span>
        </span>
      )}
    </span>
  );

  if (!linkTo) return mark;

  return (
    <Link aria-label="Paused FYI" className="shrink-0" to={linkTo}>
      {mark}
    </Link>
  );
}
